// extracted by mini-css-extract-plugin
module.exports = {"logo":"Icon_logo__qvuf2"};